import React, {memo} from 'react'
import classNames from 'classnames'
import css from './style.module.scss'
import Icon from './icon'

const Contacts = ({type, disabled}) => {
  if (disabled) return
  return (
    <div className={classNames(
      css.contacts,
      type === 'home' ? css.contactsHome : css.contactsInner
    )}>
      <div className={css.icons}>
        <Icon name="fb" />
        <Icon name="instagram" />
      </div>
    </div>
  )
}

export default memo(Contacts)
